import { FC } from 'react';

import { Box, Flex, InformationCircleSolid, StyleProps, Text } from '@bonusly/design-system';

export const RequiresApprovalBanner: FC<StyleProps & { title: string; description: string }> = ({ title, description, ...props }) => {
	const textStyles = {
		color: 'gray.900',
		fontSize: 'sm',
		lineHeight: 'base',
	};

	return (
		<Flex bg="gray.25" borderRadius="md" direction="row" px={3} py={2} {...props}>
			<InformationCircleSolid color="gray.500" />

			<Box ml={2}>
				<Text fontWeight="semibold" {...textStyles}>
					{title}
				</Text>
				<Text fontWeight="normal" {...textStyles}>
					{description}
				</Text>
			</Box>
		</Flex>
	);
};
